import * as styles from './index.module.scss';

import { PrivacyCalifornia as PrivacyCaliforniaContent } from 'supplemental-page-content';

const PrivacyCalifornia = () => (
  <div className={`${styles['privacy-container']}`}>
    <div className={`${styles['container']} container`}>
      <PrivacyCaliforniaContent domain="CallAPro.com" isTrademarked={true} />
    </div>
  </div>
);

export default PrivacyCalifornia;
